import { Medicine } from "./types";

export const COLLECTION_NAME = "VOLIFT";

export const INTRO_HINT_SCREEN_DURATION = 5000;

export const MEDICINE_INTRO_DURATION = 2500;

export const ANSWER_FEEDBACK_DURATION = 2500;

export const OUTRO_HINT_SCREEN_DURATION = 5000;

export const medicinesData: Medicine[] = [
  {
    name: "VOLIFT",
    className: "volift",
    intro: "LET'S START",
    logo: "volift-logo.png",
    questions: [
      {
        id: 1,
        question: "WHAT IS THE CONCENTRATION PERCENTAGE OF VOLIFT ?",
        correctAnswerId: 1,
        answers: [
          {
            id: 1,
            answer: "17.5",
            image: "volift-q1-ans1.png",
          },
          {
            id: 2,
            answer: "24",
            image: "volift-q1-ans2.png",
          },
        ],
      },
      {
        id: 2,
        question: "WHAT IS THE DURATION OF EFFECTIVENESS OF VOLIFT?",
        correctAnswerId: 2,
        answers: [
          {
            id: 1,
            answer: "12",
            image: "volift-q2-ans1.png",
          },
          {
            id: 2,
            answer: "18",
            image: "volift-q2-ans2.png",
          },
        ],
      },
      {
        id: 3,
        question: "CHOOSE THE COHESIVITY?",
        correctAnswerId: 1,
        answers: [
          {
            id: 1,
            answer: "30",
            image: "volift-q3-ans1.png",
          },
          {
            id: 2,
            answer: "96",
            image: "volift-q3-ans2.png",
          },
        ],
      },
    ],
  },
  {
    name: "ULTRA 4",
    className: "ultra-4",
    intro: "NOW WITH",
    logo: "ultra-logo.png",
    questions: [
      {
        id: 1,
        question: "HOW LONG DOES ULTRA 4 LAST?",
        correctAnswerId: 2,
        answers: [
          {
            id: 1,
            answer: "Up to 8 months depending on injection area",
          },
          {
            id: 2,
            answer: "Up to 1 year depending on injection area",
          },
        ],
      },
      {
        id: 2,
        question:
          "CHOOSE THE OPTION THAT DOESN'T MATCH WHAT ULTRA 4 IS USED FOR?!",
        correctAnswerId: 3,
        answers: [
          {
            id: 1,
            answer: "CHEEK ENHANCEMENT",
          },
          {
            id: 2,
            answer: "JAWLINE SCULPTING",
          },
          {
            id: 3,
            answer: "TREAT SWEATING",
          },
        ],
      },
    ],
  },
  {
    name: "VOLUMA",
    className: "voluma",
    intro: "NOW WITH",
    logo: "voluma-logo.png",
    questions: [
      {
        id: 1,
        question: "HOW LONG DOES VOLUMA LAST?",
        correctAnswerId: 1,
        answers: [
          {
            id: 1,
            answer: "Up to 2 years",
          },
          {
            id: 2,
            answer: "Up to 1 year",
          },
        ],
      },
      {
        id: 2,
        question:
          "TREATS MID FACE, ADDS VOLUME TO THE CHEEKS, LIFTING AND CONTOURING THEM?",
        correctAnswerId: 1,
        answers: [
          {
            id: 1,
            answer: "True",
          },
          {
            id: 2,
            answer: "False",
          },
        ],
      },
    ],
  },
  {
    name: "VOLUX",
    className: "volux",
    intro: "NOW WITH",
    logo: "volux-logo.png",
    questions: [
      {
        id: 1,
        question: "SCULPTS THE JAWLINE AND ADD DEFINITION ?",
        correctAnswerId: 1,
        answers: [
          {
            id: 1,
            answer: "True",
          },
          {
            id: 2,
            answer: "False",
          },
        ],
      },
      {
        id: 2,
        question: "HOW LONG DOES VOLUX LAST?",
        correctAnswerId: 2,
        answers: [
          {
            id: 1,
            answer: "Up to 1 year",
          },
          {
            id: 2,
            answer: "from 18 to 24 months",
          },
        ],
      },
    ],
  },
];

export const BOLD_WORDS = [
  "CONCENTRATION",
  "DURATION",
  "THE COHESIVITY",
  "TREATS MID FACE",
];

export const WHTIE_WORDS = ["ULTRA 4", "VOLUMA", "VOLUX"];
